import {createFeatureSelector, createSelector} from "@ngrx/store";
import {HttpActionState} from "../../users/userslisting/store/users-listing.reducers";
import {LegalHubPlaybooksListingFeatureKey} from "./playbooks.config";
import {IPlaybookListeningState, playbookListingAdapter} from "./playbooks.reducers";

const {selectAll} = playbookListingAdapter.getSelectors();

export const state = createFeatureSelector<IPlaybookListeningState>(LegalHubPlaybooksListingFeatureKey);
export const isLoading = createSelector(state, (state=> state.fetchPlaybooksRequestState ===  HttpActionState.Busy));

export const playbooksSelectors = createSelector(state, state=>state.playbooks);
export const playbooks = createSelector(playbooksSelectors, selectAll);
export const search = createSelector(state, state => state.search);
export const defaultFilters = createSelector(state, state => state.defaultFilters);
export const paging = createSelector(state, state => state.paging);

export const categories = createSelector(state, state => state.categories);
export const isCategoriesLoading = createSelector(state, state => state.fetchCategoriesRequestState ===  HttpActionState.Busy);